module.exports = __webpack_public_path__ + "static/img/1.26a1eff.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/4/1/zh/1.png
// module id = MFpW
// module chunks = 0